
$(document).ready(function () {

    function priceFormat(price) {
        return price.toLocaleString('ru-RU', {maximumFractionDigits: 1, minimumFractionDigits: 0});
    }

    // for password input 
    $(document).on('click', '.change-type', function() {
        let passInput = $(this).siblings('input');
        $(this).toggleClass('showed');
        if(passInput.attr('type') == "password") {
            passInput.attr('type', 'text');
        } else {
            passInput.attr('type', 'password');
        }
    });

    //for registration 
    $('.for-' + $('input[name="purpose"]:checked').attr('id')).show().css('display', 'flex');
    $('.for-' + $('input[name="purpose"]:checked').attr('id')).find('input').prop('required', true);
    $('input[name="purpose"]').on('change', function() {
        $('.form-row.for-purposeA, .form-row.for-purposeP').hide();
        if($(this).attr('id') === 'purposeA') {
            $('.for-purposeA').show().css('display', 'flex');
            $('.for-purposeA').find('input').prop('required', true);
            $('.for-purposeP').find('input').prop('required', false);
        }
        else if($(this).attr('id') === 'purposeP') {
            $('.for-purposeP').show().css('display', 'flex');
            $('.for-purposeP').find('input').prop('required', true);
            $('.for-purposeA').find('input').prop('required', false);
        }
    });

    $('.base-content').on('change', '.social-checkbox input', function() {
        $('.for-social').fadeIn(50);
    });

    $('.radio-group').on('change', 'input.js-profile-messenger', function() {
        $(this).closest('form').find('.for-social').fadeOut(0);
        $(this).closest('form').find('.for-social input').prop('required', false);
        $(this).closest('.radio-group').next('.for-social').fadeIn(50);
        $(this).closest('.radio-group').next('.for-social').find('input').prop('required', true);
    });

    //new name input in modal
    $('body').on('focus', '.for-new-name input', function() {
        $(this).closest('.modal-content').find('input:checked').prop('checked', false);
        $(this).closest('.for-new-name').siblings('.radio-new-name').find('input').prop('checked', true);
    });
    
    $('.wrap_popup').on('click', '.confirm-btn', function() {
        if($(this).closest('.modal-content').find('.radio-new-name input').is(':checked')) { 
            if(!$(this).closest('.modal-content').find('.for-new-name input').val().length) {
                $(this).closest('.modal-content').find('.for-new-name label').show();
            }
        }
    });

    $('.modal-content').find('.for-new-name input').on('keyup', function() {
        if($(this).val().length) {
            $(this).siblings('label').hide();
        } else {
            $(this).siblings('label').show();
        }
    });

    $('.wrap_popup').on('change', 'input[type="radio"]', function() {
        if(!$(this).parent().hasClass('radio-new-name') && $(this).is(':checked')) {
            $(this).parent().siblings('.for-new-name').find('label').hide();
        }
    });
    
    // payment
    $('.js-payment-amount').on("keypress keyup blur",function (event) {
        var $amount = $(this);
        $('.js-commission').each(function( index ) {
            var commission = $(this).attr('data-commission');
            if (commission) {
                $(this).find('span').text(priceFormat($amount.val() - ($amount.val() / 100 * commission)));
            }
        })
    });

    /**
     * Phone mask
     */
    // $('.phone_inputmask').inputmask({
    //     "oncomplete": function () {
    //         $(this).addClass('completed');
    //     },
    //     "onincomplete": function () {
    //         $(this).removeClass('completed');
    //     },
    //     alias: "phone", 
    //     "clearIncomplete": true
    // });

    var maskList = $.masksSort($.masksLoad("/js/inputmask-multi/phone-codes.json"), ['#'], /[0-9]|#/, "mask");
    var maskOpts = {
        inputmask: {
            definitions: {
            '#': {
                validator: "[0-9]",
                cardinality: 1
            }
            },
            showMaskOnHover: false,
            autoUnmask: true,
        },
        match: /[0-9]/,
        replace: '#',
        list: maskList,
        listKey: "mask",
        onMaskChange: function(maskObj, completed) {
            $(this).attr("data-mask", maskObj.mask);
            $(this).attr("data-mask-len", maskObj.mask.length);
        },
    };
    
    $('.phone_inputmask').each(function() {
        var elem = $(this);
        elem.inputmasks(maskOpts);
    });

    $('.phone_inputmask').blur(function() {
        var elem = $(this);
        
        if ( elem.val() != '' ) {
            var complete = elem.inputmasks('isCompleted');
        }
    });
    
    $('.phone_inputmask').on('mousedown', function() {
        var elem = $(this);
        if($(this).val().length == 0) {
            // elem.val('+380');
            // for cursor is at the end
            var that = this;
            setTimeout(function(){ that.selectionStart = that.selectionEnd = 10000; }, 0);
        }
    });
    
    $('#webmoney_wallet').inputmask('Z999999 999 999', {
        "oncomplete": function () {
            $(this).addClass('completed');
        },
        "onincomplete": function () {
            $(this).removeClass('completed');
        },
        'translation': {
            0: {
                pattern: /[0-9*]/
            }
        }
    });
    $('#yandex_wallet').inputmask({
        regex: "^[0-9]{11,15}$",
        "oncomplete": function () {
            $(this).addClass('completed');
        },
        "onincomplete": function () {
            $(this).removeClass('completed');
        },
        'translation': {
            0: {
                pattern: /[0-9*]/
            }
        }
    });
    $('#visa_card').inputmask('9999 9999 9999 9999', {
        "oncomplete": function () {
            $(this).addClass('completed');
        },
        "onincomplete": function () {
            $(this).removeClass('completed');
        },
    });

    /**
     * Form validate
     */
    $.validator.methods.email = function (value, element) {
        return this.optional(element) || /^([а-яА-Яa-zA-Z0-9_.+-])+\@(([а-яА-Яa-zA-Z0-9-])+\.)+([а-яА-Яa-zA-Z0-9]{2,})+$/.test(punycode.toUnicode(value));
    };
    $.validator.methods.tel = function (value, element) {
        let mask = $(element).data('mask');
        return this.optional(element) || mask.match(/[0-9#]/g).length == value.toString().length;
    };

    
    $.validator.addMethod("webmoney-wallet", function(value, element) {
        return this.optional(element) || /^[Z]{1}[\d\s]+$/i.test(value);
    });

    $('.webmoney_wallet_input').on('input', function() {
        $(this).val($(this).val().replace(/[^Z0-9]/g,''));
    });
    
    $.validator.addMethod("yandex-wallet", function(value, element) {
        return this.optional(element) || /^[\d\s]+$/i.test(value);
    });

    $('.yandex_wallet_input').on('input', function() {
        $(this).val($(this).val().replace(/[^Z0-9]/g,''));
    });

    $.validator.addMethod("visa-card", function(value, element) {
        return this.optional(element) || /^[\d\s]+$/i.test(value);
    });

    $('.visa_card_input').on('input', function() {
        $(this).val($(this).val().replace(/[^\d]/g,''));
    });

    // allow numeric without decimal
    $(".allownumericwithoutdecimal").on("keypress keyup blur",function (event) {  
        let eventKey = event.which || event.keyCode;  
        $(this).val($(this).val().replace(/[^\d].+/, ""));
        if ((eventKey < 48 || eventKey > 57)) {
            event.preventDefault();
        }
    });
    $('.validate .allownumericwithoutdecimal').each(function() {
        $(this).rules('add', {
            required: true,
            min: 1,
        });
    });
});